import _ from 'underscore';
import booleanField from '@bingads-webui-component-legacy/form/view/field/boolean';
import enumField from '@bingads-webui-component-legacy/form/view/field/enum';
import integerField from '@bingads-webui-component-legacy/form/view/field/integer';
import numberField from '@bingads-webui-component-legacy/form/view/field/number';
import stringField from '@bingads-webui-component-legacy/form/view/field/string';
import Url from '@bingads-webui-component-legacy/form/view/field/url';
import TrackingTemplate from '@bingads-webui-component-legacy/form/view/field/tracking-template';
import CustomParams from '@bingads-webui-component-legacy/form/view/field/custom-params';

const mapping = {
  boolean: booleanField,
  enum: enumField,
  integer: integerField,
  number: numberField,
  string: stringField,
  // TODO: [zhbliu] remove this out before we open source this component
  Url,
  TrackingTemplate,
  CustomParams,
};

// TODO: [zhbliu] merge view and control
export default (attrs = {}) => {
  let key;

  if (attrs.format) {
    key = attrs.format;
  } else {
    key = _.isEmpty(attrs.enum) ? attrs.type : 'enum';
  }

  const field = mapping[key];

  if (_.isFunction(field)) {
    return field(attrs);
  }

  return field;
};
